export default function GetStartedPage() {
  return (
    <div className="min-h-screen bg-gray-950 text-white flex flex-col items-center justify-center">
      <h1 className="text-4xl font-bold mb-6">Get Started</h1>
      <p className="text-lg max-w-2xl text-center">
        Ready to try it out? Follow the steps to set up your environment and start typing with gestures!
      </p>
    </div>
  );
}
